(function (angular) {
	'use strict';

	var versionCheck = function (pmtEnvService) {
		var that = this;
		that.isCurrentVersion = true;

		var baseUrl = pmtEnvService.listingsManagerUrl
			.replace('https', 'wss')
			.replace('/listings/', '/');
		var socketUrl = baseUrl + 'version';

		var version = io.connect(socketUrl, { transports: ['websocket'], path: '/listings/socket.io' });

		version.on('version', function (data) {
			that.isCurrentVersion = window.pmtVersionCheckHash
				? window.pmtVersionCheckHash === data
				: true;
		});
	};

	angular.module('PinMeTo.versionCheck', []);
	angular
		.module('PinMeTo.versionCheck')
		.service('pmtVersionCheck', ['pmtEnvService', versionCheck]);
})(window.angular);
